import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTopic from '../../../../components/newsTopic';
import ContentTitle from '../../../../components/contentTitle';
import NewsList from '../../../../components/newsList';
import NewsBox from '../../../../components/newsBox';

class VipBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { vipTopic, vipTitle, vipList0, vipList1, vipBoxData0, vipBoxData1 },
        } = this.props;

        return (
            <div id="vipNewsList" className={styles.vip_box}>
                <Chip id="50085" type="struct" title="视频标题" groupName="视频" content={vipTopic}>
                    <NewsTopic />
                </Chip>
                <Chip
                    id="75119"
                    type="recommend"
                    title="视频头条"
                    groupName="视频"
                    content={vipTitle}
                    translate="handleNewsContentData">
                    <ContentTitle />
                </Chip>
                <Chip
                    id="75120"
                    type="recommend"
                    title="视频新闻列表"
                    groupName="视频"
                    content={vipList0}
                    translate="handleNewsContentData">
                    <NewsList isList />
                </Chip>
                <Chip
                    id="75121"
                    type="recommend"
                    title="互娱动漫新闻列表"
                    groupName="视频"
                    content={vipList1}
                    translate="handleNewsContentData">
                    <NewsList isList />
                </Chip>
                <div className={styles.fl}>
                    <Chip
                        id="75122"
                        type="recommend"
                        title="互娱动漫新闻盒1"
                        groupName="视频"
                        content={vipBoxData0}
                        translate="handleNewsBoxData">
                        <NewsBox />
                    </Chip>
                </div>
                <div className={styles.fr}>
                    <Chip
                        id="75123"
                        type="recommend"
                        title="互娱动漫新闻盒2"
                        groupName="视频"
                        content={vipBoxData1}
                        translate="handleNewsBoxData">
                        <NewsBox />
                    </Chip>
                </div>
            </div>
        );
    }
}

export default errorBoundary(VipBox);
